<template>
  <div>
    <projectOperations/>
    <pages-medias-vue :project="this.element"></pages-medias-vue>
  </div>
</template>

<script>
import pagesMediasVue from "../page-medias/pages-medias.vue";
import projectOperations from "@/components/projects/project-operations-toolbar.vue";

export default {
  components: {
    pagesMediasVue,
    projectOperations
  },
  data() {
    return {
      element: null,
    };
  },
  methods: {
  },

};
</script>

<style scoped>
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
.disable-pre {
  display: none;
}
</style>
